import {
  DELETE,
  GET,
  POST,
  PUT,
  UPLOAD_FILE,
  UPLOAD_FILE_WITH_METHOD,
} from "../../apiController";

const endpoint = "/admin/courses";

// get module content
export const getCourseModuleContent = (data) => {
  return GET(endpoint + `/modules-content/${data.module_id}`);
};

// create assessment
export const createAssessmentAPI = (data) => {
  return POST(endpoint + `/assessment`, data); // Calls the backend API to create an assessment
};

export const createDocument = (data) => {
  return UPLOAD_FILE(endpoint + `/document`, data);
};

export const createVideoAPI = (data) => {
  return UPLOAD_FILE(endpoint + `/video/upload`, data);
};

export const deleteContentById = async (data) => {
  return DELETE(endpoint + `/module-content/${data.content_id}/${data.type}`);
};

export const changeContentstatus = (params, data) => {
  return PUT(
    endpoint +
    `/modules-content-active-deactive/${params.module_id}/${params.content_id}`,
    data
  );
};

// update content order
export const updateContentOrder = (data) => {
  return POST(endpoint + `/content-order-update`, data);
};

export const EditVideoContent = (data) => {
  return UPLOAD_FILE_WITH_METHOD(endpoint + `/course/edit-video`, data, "PUT");
};

export const editDocument = (data) => {
  return UPLOAD_FILE(endpoint + `/course/edit-document`, data); // Use POST method as defined in backend route
};

export const editAssessment = (data) => {
  return PUT(endpoint + `/edit-assessment`, data);
};